import { call, put, takeLatest } from "redux-saga/effects";
import { sagaActions } from "./sagaActions";
import { callGetAPI } from "../API";
import { SERVER_API } from "../../helper/Constants";

function* fetchSpices() {
  try {
    const spices = yield call(() => callGetAPI(SERVER_API.SPICES));
    yield put({ type: sagaActions.SPICES_LOAD, data: spices.data });
  } catch (e) {
    yield put({ type: sagaActions.API_FAILED, message: e.message });
  }
}

function* watchFetchSpicesAsync() {
  yield takeLatest(sagaActions.SPICES_LOAD_REQUEST, fetchSpices);
}

export default watchFetchSpicesAsync;
